import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Observable } from 'rxjs';

import { TranslationConstants } from '../../../../../shared/constants';

import {
  ClosableModalWithErrorResponseModel
} from '../../../../../shared/components/base/closable-modal-with-error-response-model';

import { NotificationService, PbasService } from '../../../../../shared/services';
import { ModalService } from '../../../../../shared/modules/modal';
import {
  CharacterizeTestedPartyOptionTypeErrorResponse,
  MinorClassificationsModalPayload,
  MinorServiceClassification,
} from '../../../../../shared/models';

@Component({
  selector: 'minor-classifications-modal',
  templateUrl: './minor-classifications-modal.component.html'
})
export class MinorClassificationsModalComponent
  extends ClosableModalWithErrorResponseModel<CharacterizeTestedPartyOptionTypeErrorResponse> implements OnInit {

  data: MinorClassificationsModalPayload;
  test: true;
  selectedMinorClassificationsIds: number[] = [];

  constructor(
    protected modalService: ModalService,
    protected notificationService: NotificationService,
    private _pbasService: PbasService,
    private _translateService: TranslateService
  ) {
    super(notificationService, modalService);
    this.validationErrors = new CharacterizeTestedPartyOptionTypeErrorResponse();
  }

  ngOnInit(): void {
    this.listenForErrorMessages();
    this.setExistingMinorServiceClassificationIds();
    this.translateMinorServiceClassificationNames();
  }

  save(): void {
    this.validateMinorClassificationsSelection();

    if (this.responseErrors.length) {
      return;
    }

    if (
      this.data.testedPartyMajorClassification.minorServiceClassifications &&
      this.data.testedPartyMajorClassification.minorServiceClassifications.length
    ) {
      this.deleteTestedPartyMinorClasifications(this.data.testedPartyMajorClassification.minorServiceClassifications)
        .subscribe(() => {
          this.addTestedPartyMinorClasifications(this.selectedMinorClassificationsIds)
            .subscribe(() => {
              this.success();
              this.close();
            });
        });
    } else {
      this.addTestedPartyMinorClasifications(this.selectedMinorClassificationsIds)
        .subscribe(() => {
          this.success();
          this.close();
        });
    }
  }

  private translateMinorServiceClassificationNames(): void {
    this.data.minorServiceClassifications.forEach((minorClassification) => {
      minorClassification.name = this._translateService.instant(minorClassification.name);
    });
    
    this.data.minorServiceClassifications.sort((minor1, minor2) => {
      return minor1 > minor2 ? 1 : -1;
    });
  }

  private validateMinorClassificationsSelection(): void {
    this.responseErrors = [];

    if (!this.selectedMinorClassificationsIds.length) {
      this.responseErrors.push(TranslationConstants.MINOR_CLASSIFICATION_REQUIRED);
    }
  }

  private deleteTestedPartyMinorClasifications(
    testedPartyMinorClassifications: MinorServiceClassification[]
  ): Observable<any[]> {
    const observables = [];

    testedPartyMinorClassifications.forEach((classification) => {
      const obsrv = this._pbasService.deleteMinorServiceClassificationsForTestedParty(
        this.data.testedParty.pba.pbaId, classification.minorServiceClassificationId
      );

      observables.push(obsrv);
    });

    return forkJoin(observables);
  }

  private addTestedPartyMinorClasifications(selectedMinorClassificationsIds: number[]): Observable<any[]> {
    const observables = [];

    selectedMinorClassificationsIds.forEach((classificationId) => {
      const obsrv = this._pbasService.addMinorServiceClassificationsForTestedParty(
        this.data.testedParty.pba.pbaId, classificationId
      );

      observables.push(obsrv);
    });

    return forkJoin(observables);
  }

  private setExistingMinorServiceClassificationIds(): void {
    const majorClassification = this.data.testedPartyMajorClassification;

    if (majorClassification.minorServiceClassifications) {
      majorClassification.minorServiceClassifications.forEach((minorClassification) => {
        this.selectedMinorClassificationsIds.push(minorClassification.minorServiceClassificationId);
      });
    }
  }
}
